import React from 'react';
import './Instructions.css';

const Instructions: React.FC = () => {
    return (
        <div>
            <div className="window-title">How to USE</div>
            <div className="window-content scrollable-content">
                <div className="instructions-inner">
                    <h2>⚡ Quick Start Guide</h2>

                    <h3>🔗 Solana (Phantom Wallet)</h3>
                    <ol>
                        <li>Open the <strong>Phantom</strong> wallet app.</li>
                        <li>Use the browser tab to go to <code>ai-crypto-assistant.vercel.app</code>.</li>
                        <li>In the terminal, type <code>connect solana</code>.</li>
                        <li>Approve the wallet connection.</li>
                        <li>Start mining: <code>mining start</code></li>
                        <li>Stop mining: <code>mining stop</code></li>
                        <li>Withdraw: <code>withdraw</code> & press <strong>Confirm</strong>.</li>
                        <li><em>(Optional)</em> Stake SOL: <code>stake</code> or <code>unstake</code></li>
                    </ol>

                    <h3>🔗 Ethereum / EVM (MetaMask)</h3>
                    <ol>
                        <li>Open <strong>MetaMask</strong> wallet app.</li>
                        <li>Use browser tab to visit <code>ai-crypto-assistant.vercel.app</code>.</li>
                        <li>Connect to any chain: <code>connect ethereum</code> or <code>connect base</code>, <code>arbitrum</code>, <code>optimism</code>, <code>bnb</code>.</li>
                        <li>Approve wallet connection.</li>
                        <li>Start mining: <code>mining start</code></li>
                        <li>Stop mining: <code>mining stop</code></li>
                        <li>Withdraw: <code>withdraw</code> & press <strong>Confirm</strong>.</li>
                        <li><em>(Optional)</em> Stake ETH or BNB: <code>stake</code> or <code>unstake</code></li>
                    </ol>

                    <h3>🧠 Notes</h3>
                    <ul>
                        <li>You can check balance using <code>balance</code></li>
                        <li>You can switch chains anytime with <code>disconnect</code> and <code>connect [chain]</code></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Instructions;
